const CAMP_SLUGS_WITH_CAMPER_COMPANY_NAME_FIELD = [
  "acadiana-beer-garden",
  "the-back-yard-food-truck-park",
  "your-rv-park",
  "dapper-haus",
]

export default CAMP_SLUGS_WITH_CAMPER_COMPANY_NAME_FIELD